import IndexModel from "@/service/v1/seguranca/IndexModel";
 
class PerfilService extends IndexModel {
      
    constructor() {
        super();
        this.url = this.url + '/Perfil';
    }
 
    public getApiUrl() {
        return this.getAxios().defaults.baseURL + this.url;
    }
       
    public getUrlLoginLog(  ) { 
        return  this.getAxios().defaults.baseURL + this.url_base + '/loginlog'; 
    }
 
    public getUrlRelatorio(  ) { 
        return this.getAxios().defaults.baseURL + this.url_relatorio + '/perfil'; 
    }
 
}
  
export default PerfilService; 